import React, {useEffect,useState} from 'react'
import {Button } from 'grommet';
import { DocumentDownload } from 'grommet-icons';
import {Storage,API,Auth} from 'aws-amplify';


function GetS3Document(props){
    const [url, setUrl] = useState();
    const [documentPresent, setDocumentPresent] = useState(false)
    const [documentName, setDocumentName] = useState('')
    const isDocumentPresent = (props) => {
        if (props === null){
            return false
        }
        else if (props === undefined){
            return false
        } else if (props === ""){
            return false
        // } else if (props === undefined || props.CommodityID === undefined){
        //     console.log('4')
        //         return false
        // }
         } else if (props.constructor === Object && props.CommodityID === undefined){
                return false
         }
         else {
            setDocumentPresent(true)
            return true
        }
    }
    useEffect(() => {
        if (props.CommodityID !== undefined){
            Auth.currentSession().then(session => {
                API
                .get("LabShip", `/commodities/${props.CommodityID}`,{headers: { 
                    Authorization: session.idToken.jwtToken,
                  }})
                .then(
                (result) => {
                    if (isDocumentPresent(result.documents_key)){
                        Storage.list(result.documents_key) 
                        .then(result => {
                            var docName = result[0].key.split("/")
                            setDocumentName(docName[1])
                                Storage.get(result[0].key).then(res => {
                                setUrl(res)
                            })   
                        })
                        .catch(err => console.log(err));
                        
                    }
                },
                (error) => {
                    console.log(error);
                }
                )
            })
           
        } else if (props.commodity !== undefined) {
            Auth.currentSession().then(session => {
                API
                .get("LabShip", `/commodities/${props.commodity.id}`,{headers: { 
                    Authorization: session.idToken.jwtToken,
                  }})
                .then(
                (result) => {
                    console.log(result)
                    console.log(result.documents_key)
                    console.log(isDocumentPresent(result.documents_key))
                    if (isDocumentPresent(result.documents_key)){
                        Storage.list(result.documents_key) 
                        .then(result => {
                            var docName = result[0].key.split("/")
                            setDocumentName(docName[1])
                                Storage.get(result[0].key).then(res => {
                                    console.log(res)
                                setUrl(res)
                            })   
                        })
                        .catch(err => console.log(err));
                        
                    }
                },
                (error) => {
                    console.log(error);
                }
                )
            })
        } else {
            if (isDocumentPresent(props)){
                Storage.list(props.commodity.documents_key) 
                .then(result => {
                    var docName = result[0].key.split("/")
                    setDocumentName(docName[1])
                        Storage.get(result[0].key).then(res => {
                        setUrl(res)
                    })   
                })
                .catch(err => console.log(err));
                
            }
        }
      }, [props]);
      if (documentPresent && documentName !== ''){
          return <a target="_blank" rel="noopener noreferrer" href={url}><Button margin="small" icon={<DocumentDownload color='status-ok'/>} label={documentName} type='button'/></a>
      } else {
          return null
      }
}

export default GetS3Document
